import { translatePblDisplayValue, type PblDisplayTranslator } from '@/utils/pblDisplayTranslation';

const normalizeBackendValue = (value?: string | null) =>
  (value || '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');

const translateLabel = (
  t: PblDisplayTranslator,
  value: string | null | undefined,
  labelKey?: string,
  defaultLabel?: string
) => {
  if (!value) return '-';
  return labelKey
    ? t(labelKey, { defaultValue: defaultLabel || value })
    : translatePblDisplayValue(t, value);
};

export const translateOcCitizenMeetingStatus = (
  t: PblDisplayTranslator,
  value?: string | null
) => {
  const normalizedValue = normalizeBackendValue(value);

  if (normalizedValue === 'scheduled') {
    return translateLabel(
      t,
      value,
      'pbl.pagesHardcoded.ocCitizens.detail.meetingStatuses.scheduled',
      'Scheduled'
    );
  }

  if (normalizedValue === 'cancelled' || normalizedValue === 'canceled') {
    return translateLabel(
      t,
      value,
      'pbl.pagesHardcoded.ocCitizens.detail.meetingStatuses.cancelled',
      'Cancelled'
    );
  }

  return translateLabel(t, value);
};

export const translateOcCitizenDocumentType = (
  t: PblDisplayTranslator,
  value?: string | null
) => {
  const normalizedValue = normalizeBackendValue(value);

  if (normalizedValue.includes('supporting_document')) {
    return translateLabel(
      t,
      value,
      'pbl.pagesHardcoded.ocCitizens.detail.documentTypes.supportingDocument',
      'Supporting document'
    );
  }

  if (normalizedValue === 'signed_document') {
    return translateLabel(
      t,
      value,
      'pbl.pagesHardcoded.ocCitizens.detail.documentTypes.signedDocument',
      'Signed document'
    );
  }

  return translateLabel(t, value);
};
